import React, { useEffect, useState } from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useHistory } from "react-router-dom";
import { fetchDataFromApi } from "@Utils";
import Table from "components/Table";
import Filter from "components/Filter";

import {
  BLOCK_FETCH_URL,
  COMPANY_FETCH_URL,
  DIVISION_FETCH_URL,
  ESTATE_FETCH_URL,
  GRIEVANCE_ASSIGNEE,
  REGION_FETCH_URL,
  ZONE_FETCH_URL,
} from "../../configs/constants";
import { useLocation } from "react-router-dom";

const URLS = {
  GRIEVANCE_STATUS: "grievance/internal-status-choices/",
};

let model = [
  { id: "grievance_id", label: "Grievance ID", type: "string" },
  {
    id: "is_audio_message",
    label: "Type",
    type: "boolean",
    yesValue: "Audio",
    noValue: "Text",
  },
  { id: "created_at", label: "Date and Time Created", type: "date_time" },
  { id: "user_id", label: "Employee ID", type: "string" },
  { id: "user_name", label: "Employee Name", type: "string" },
  { id: "internal_status", label: "Status", type: "string" },
  { id: "estate", label: "Estate", type: "string" },
  { id: "assignee", label: "Assignee", type: "string" },
];

// Please do not remove these lines of code
const today = new Date();
const options = { timeZone: 'Asia/Kuala_Lumpur' };
let date = today.toLocaleDateString('en-GB', options);
date = date.split('/').reverse().join('-');
const dateAfterThreeDays = new Date(
  new Date().setDate(new Date().getDate() + 3)
);



const GrievanceList = () => {
  const details = useLocation();
  let filters = {};
  if ("filters" in details) {
    if (details.filters.date_from) {
      filters["date_from"] = details.filters.date_from;
    }
    if (details.filters.date_to) {
      filters["date_to"] = details.filters.date_to;
    }
    if (details.filters.status) {
      filters["internal_status"] = details.filters.status;
    }
  }
  const [filterValues, setFilterValues] = useState(filters);
  const [grievanceChoices, setGrievanceChoices] = useState([]);
  const [grievanceAssigneeChoices, setGrievanceAssigneeChoices] = useState([]);
  const [selectedFormDate, setSelectedFormDate] = useState(null);
  const [selectedtoDate, setSelectedToDate] = useState(null);
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableDivision, setDisableDivision] = useState(true);
  const [disableBlock, setDisableBlock] = useState(true);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [disableZone, setDisableZone] = useState(true);

  const history = useHistory();
  const pageNumberDropdown = true;
const actions = [
  //          {
  //   type: "view",
  //   title: "View",
  //   icon: <VisibilityIcon />,
  //   color: "secondary",
  //   onClick: (id) => history.push(`${history.location.pathname}/view-details/${id}`),
  // },
    "edit"];

  useEffect(() => {
    fetchDataFromApi(URLS.GRIEVANCE_STATUS, setGrievanceChoices, false);
    fetchDataFromApi(GRIEVANCE_ASSIGNEE, setGrievanceAssigneeChoices, false);
  }, []);

  const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };
  const getZoneValues = (e,setDisableRegion) => {
    if (!e || e.length === 0) {
      setDisableRegion(true);
    }
    else {
      setDisableRegion(false);
    }
    
  };
  const getRegionValues = (e,setDisableEstate) => {
    if (!e || e.length === 0) {
      setDisableEstate(true);
    }
    else {
      setDisableEstate(false);
    }
    
  };
  
  const getEstateValues = (e,setDisableDivision) => {
    if (!e || e.length === 0) {
      setDisableDivision(true);
    }
    else {
      setDisableDivision(false);
    }
    
  };
  const getDivisonValues = (e,setDisableBlock) => {
    if (!e || e.length === 0) {
      setDisableBlock(true);
    }
    else {
      setDisableBlock(false);
    }
    
  };
  const getFormDate = (e) => {
    setSelectedFormDate(e);
  };
  const getToDate = (e) => {
    setSelectedToDate(e);
  };
  const filterInitialValues = {
    date_from: details?.filters?.date_from || date,
    date_to: details?.filters?.date_to || date,
    internal_status: details?.filters?.status || null,
    grievance_id: "",
    assignee: "",
    //internal_status: "",
    company: "",
    zone: "",
    region: "",
    estate: "",
    division: "",
    block: "",
  };

  const filterFields = [
    {
      type: "datepicker",
      label: "From Date",
      name: "date_from",
      emptyLabel: "DD/MM/YYYY",
      maxDate:selectedtoDate,
      getValue: getFormDate,
    },
    {
      type: "datepicker",
      label: "To Date",
      name: "date_to",
      emptyLabel: "DD/MM/YYYY",
      minDate: selectedFormDate,
      getValue: getToDate,
    },
    {
      type: "input",
      label: "Grievance ID",
      name: "grievance_id",
    },
    {
      type: "reactselect",
      label: "Assignee",
      name: "assignee",
      outerOptions: grievanceAssigneeChoices,
    },
    {
      type: "reactselect",
      label: "Status",
      name: "internal_status",
      outerOptions: grievanceChoices,
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,
  
  
    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: false,
      isPaginationEnabled: false,
      isAllowablesEnabled: false,
      disabled:disableZone,
      optionsDependsOn: "company",
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: false,
      disabled:disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
      isPaginationEnabled: false,
      isAllowablesEnabled: false,


    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      paginated: false,
      disabled:disableEstate,
      getValue: (e) => getEstateValues(e, setDisableDivision),
      isPaginationEnabled: false,
      isAllowablesEnabled: false,
      optionsDependsOn: "region",
    },
    {
      type: "reactselect",
      name: "division",
      label: "Division",
      proxyUrl: DIVISION_FETCH_URL,
      paginated: true,
      disabled:disableDivision,
      getValue: (e) => getDivisonValues(e, setDisableBlock),

      optionsDependsOn: "estate",
    },
    {
      type: "reactselect",
      name: "block",
      label: "Block",
      proxyUrl: BLOCK_FETCH_URL,
      paginated: true,
      disabled:disableBlock,

      optionsDependsOn: "division",
    },
  ];

  const onFilterRequest = (values) => {
    setFiltersApplied(true);

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };
  const clearFilter =()=>{
    filterInitialValues.status = null
    location.reload();
   }

  return (
    <>
      <div>
        <Filter
          initialValues={filterInitialValues}
          filterFields={filterFields}
          onSubmit={onFilterRequest}
          onClear={clearFilter}

        />
              {filtersApplied ? (

        <Table
          proxyURL="grievance/bo-list/"
          actions={actions}
          model={model}
          excelExport={{ fileName: "GrievanceReport" }}
          filterValues={filterValues}
          noFilter
          noAddButton
          pageNumberDropdown={pageNumberDropdown}

        />
        ) : (
          <Table
          proxyURL={null}
          actions={actions}
          model={model}
          excelExport={{ fileName: "GrievanceReport" }}
          filterValues={filterValues}
          noFilter
          noAddButton
          pageNumberDropdown={pageNumberDropdown}

        />
)}
      </div>
    </>
  );
};

export default GrievanceList;
